export const LOCATION_SHORT_NAME = "location"
export const locationDefault = "Los Angeles, CA"

export const LATITUDE_SHORT_NAME = "latitude"
export const latitudeDefault = 34.05223

export const LONGITUDE_SHORT_NAME = "longitude"
export const longitudeDefault = -118.24368

export const NE_LATITUDE_SHORT_NAME = "ne_lat"
export const NE_LONGITUDE_SHORT_NAME = "ne_lng"
export const SW_LATITUDE_SHORT_NAME = "sw_lat"
export const SW_LONGITUDE_SHORT_NAME = "sw_lng"

export const LOCATION_FILTER_CONFIG = {
  short_name: LOCATION_SHORT_NAME,
  default_values: locationDefault,
  format_to_api: value => formatLocationForAPI(value),
  format_from_url: value => formatLocationInfoFromURL(value)
}

export const LATITUDE_FILTER_CONFIG = {
  short_name: LATITUDE_SHORT_NAME,
  default_values: latitudeDefault,
  format_to_api: value => formatLatitudeForAPI(value),
  format_from_url: value => formatLocationInfoFromURL(value)
}

export const LONGITUDE_FILTER_CONFIG = {
  short_name: LONGITUDE_SHORT_NAME,
  default_values: longitudeDefault,
  format_to_api: value => formatLongitudeForAPI(value),
  format_from_url: value => formatLocationInfoFromURL(value)
}


export const formatLocationInfoFromURL = value => {
  let cleanValue = null
  if (value) {
      cleanValue = value
  }
  return cleanValue
}


export const formatLocationForAPI = value => {
  if (value) {
    return { location: value }
  } else {
    return {}
  }
}

export const formatLatitudeForAPI = value => {
  if (value) {
    return { latitude: value }
  } else {
    return {}
  }
}

export const formatLongitudeForAPI = value => {
  if (value) {
    return { longitude: value }
  } else {
    return {}
  }
}
